import(/* webpackMode: "eager", webpackExports: ["PriceCalculator"] */ "/app/dashboard/app/_components/PriceCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
